import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Spinner } from "reactstrap";

import { useHistory, useParams, useLocation } from "react-router-dom";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; 
import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";
import ProductReviewTable from "../ProductReviewTable";
import { postRequest } from "components/Common/Utils";

export default function ProductDetails() {
  const location = useLocation();
  const _id = useParams();
  const state = location.state?.row;
  const [userAllDetails, setuserAllDetails] = useState({});
  const [loader, setLoader] = useState(false);
  const [imageLB, setImage] = React.useState("");

  const [openLightbox, setOpenLightBox] = React.useState(false);

  const useStyles = makeStyles({
    tableHeader: {
      color: "#ffffff", // Use your preferred color
      backgroundColor: "#3f51b5", // Header background color
      fontWeight: "bold",
    },
    descriptionText: {
      fontSize: "0.8rem",
    },
    deleteIcon: {
      color: "red",
    },
    roundImage: {
      borderRadius: "50%",
      width: "75px",
      height: "75px",
    },
    roundImageSm: {
      borderRadius: "50%",
    },

    gridList: {
      width: "100%",
    },
    icon: {
      color: "rgba(255, 55, 25, 0.54)",
    },
  });

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };


  useEffect(() => {
    fetchProductDetails();
  }, [_id]);

  const fetchProductDetails = async () => {
    setLoader(true);
    const payload = {
      productId: _id?.id
    };
    try {
      const response = await postRequest(`product/product-details`, payload);
      const data = response.data;
      setuserAllDetails(data);
      setProductData(data?.userDetail);
      console.log("table data", data.bannerData);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  // const {
  //   description,
  //   unit,
  //   images,
  //   country_code,
  //   sku,
  //   slug,
  //   minimumQuantity,
  //   priceRange,
  //   mobile,
  //   dob,
  //   createdAt,
  //   name,
  // } = userAllDetails;

  // console.log({ state });

  return (
    <>
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>Product Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">Product Management</li>:{" "}
              <li className="breadcrumb-item">Product details</li>
            </ol>
          </div>
        </Col>
        <div className="col-md-2 text-end">
          <button
            type="button"
            class="btn btn-primary btn-lg"
            onClick={() => history.back()}
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>

        {loader ? (
          <CardBody style={{ height: "100px" }}>
            <Spinner
              color="info"
              style={{
                height: "4rem",
                width: "4rem",
                position: "absolute",
                left: "50%",
              }}
            >
              Loading...
            </Spinner>
          </CardBody>
        ) : (
          <>
            <Card className="custom-card">
            <div className="carousel-wrapper" style={{height : '200px'}}>
      <Carousel 
        autoPlay 
        infiniteLoop 
        showThumbs={false} 
        showStatus={false} 
        emulateTouch 
        dynamicHeight 
      >
        {userAllDetails?.images?.map((image, index) => (
          <div 
            key={index} 
            className="cover-image"
            style={{ 
              backgroundImage: `url(${image})`,  
            }}
            onClick={()=>showLightBox(image)}
          >
            {/* Optionally add text or content overlay here */}
          </div>
        ))}
      </Carousel>
    </div>

              <div className="profile-image">
                <img
                  src={
                    userAllDetails?.images
                      ? userAllDetails?.images[0]
                      : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.name}`
                  }
                  onClick={()=>showLightBox(userAllDetails?.images[0])}
                  alt="Image Not Available"
                />
              </div>
              <br></br>

              <div className="row my-2 py-2">
                <div
                  className="userinfo col-md-12 "
                  style={{ paddingLeft: "20px" }}
                >
                  <div className="fst">
                    {" "}
                    <h3> {userAllDetails?.name} </h3>{" "}
                  </div>
                  <div className="row">
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Product Description: <span>{userAllDetails?.description}</span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Unit: <span> {userAllDetails?.unit} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Minimum Product Quantity:{" "}
                        <span> {userAllDetails?.priceRange?.[0]?.minQuantity} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Sku: <span> {userAllDetails?.sku} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Slug <span> {userAllDetails?.slug} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      <p>
                        {" "}
                        Created At:
                        <span> {formatDate(userAllDetails?.createdAt)}</span>
                      </p>
                    </div>
                  </div>

                  <div className="row mt-3">
                    <h3>Product Price Range</h3>

                    {userAllDetails?.priceRange?.map((item) => (
                      <React.Fragment key={item._id}>
                        <div className="col-md-4 fst py-1">
                          <p>
                            Product Name: <span>{userAllDetails?.name}</span>
                          </p>
                        </div>

                        <div className="col-md-4 fst py-1">
                          <p>
                            Unit: <span>{userAllDetails?.unit}</span>
                          </p>
                        </div>

                        <div className="col-md-4 fst py-1">
                          <p>
                            Quantity Range:{" "}
                            <span>
                              {item.minQuantity} - {item.maxQuantity}
                            </span>
                          </p>
                          <p>
                            Price: <span>${item.price}</span>
                          </p>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              </div>
            </Card>
            <Col md="12">
              <div
                id="exTab2"
                className="twitter-like-tabs2"
                style={{ background: "#ffff", marginLeft: "25px" }}
              >
                <ul
                  className="nav nav-pills"
                  style={{ width: "480px", display: "contents" }}
                >
               

                  <li className="active">
                    <a href="#reviews" data-toggle="tab">
                      {" "}
                      Reviews{" "}
                    </a>
                  </li>

             
                </ul>
              </div>
            </Col>
            <Col md="12">
              <div className="tab-content clearfix">
                <div className="tab-pane active show padded-tab" id="bookings">
              
                    <ProductReviewTable userId={userAllDetails?._id} />
          
                </div>

             

        
              </div>
            </Col> 
          </>
        )}

        {openLightbox && (
          <Lightbox
            mainSrc={imageLB}
            onCloseRequest={() => setOpenLightBox(false)}
          />
        )}
      </Row>
      <ToastContainer />{" "}
    </>
  );
}
